var _path, _path2, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackgroundsquares1Hero(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100vw",
    height: "auto",
    viewBox: "0 -96 1920 1344",
    preserveAspectRatio: "xMidYMid meet",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 1248H1920V-2.57492e-05H0V1248Z",
    fill: "#0C0C11"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_614_2244",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: -96,
    width: 1920,
    height: 1344
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 1248H1920V-96H0V1248Z",
    fill: "url(#paint0_radial_614_2244)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_614_2244",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(960 576) scale(750 525)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.946
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.955,
    stopColor: "white",
    stopOpacity: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_614_2244)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M128 1248H0V1120H128M128 1248V1120M128 1248H255.999V1120H128M256 1248H384V1120H256V1248ZM512 1248H639.999V1120H512V1248Z",
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640 1248H768V1120H640V1248Z",
    fill: "#404249",
    fillOpacity: 0.619608,
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M768 1248H896V1120H768V1248Z",
    fill: "#404249",
    fillOpacity: 0.227451,
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M896 1248H1024V1120H896V1248Z",
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1024 1248H1152V1120H1024V1248Z",
    fill: "#404249",
    fillOpacity: 0.376471,
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1152 1248H1280V1120H1152V1248Z",
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1280 1248H1408V1120H1280V1248Z",
    fill: "#404249",
    fillOpacity: 0.215686,
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1536 1248H1408V1120H1536M1536 1248V1120M1536 1248H1664M1536 1120H1664M1664 1248V1120M1664 1248H1792V1120H1664",
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1792 1248H1920V1120H1792V1248Z",
    fill: "#404249",
    fillOpacity: 0.215686,
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 1120H128V992.001H0V1120Z",
    fill: "#404249",
    fillOpacity: 0.839216,
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128 1120H256V992.001H128V1120Z",
    fill: "#404249",
    fillOpacity: 0.882353,
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256 1120H384V992.001H256V1120Z",
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384 1120H512V992.001H384V1120Z",
    fill: "#404249",
    fillOpacity: 0.211765,
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512 1120H640V992.001H512V1120Z",
    fill: "#404249",
    fillOpacity: 0.301961,
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640 1120H768V992.001H640V1120Z",
    fill: "#404249",
    fillOpacity: 0.52549,
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M768 1120H896V992.001H768V1120Z",
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M896 1120H1024V992.001H896V1120Z",
    fill: "#404249",
    fillOpacity: 0.34902,
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1152 1120H1024V992.001H1152M1152 1120V992.001M1152 1120H1280V992.001H1152",
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1280 1120H1408V992.001H1280V1120Z",
    fill: "#404249",
    fillOpacity: 0.458824,
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1536 1120H1408V992.001H1536M1536 1120V992.001M1536 1120H1664V992.001H1536",
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 992H128V864H0V992Z",
    fill: "#404249",
    fillOpacity: 0.0235294,
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384 992H256.001V864H384M384 992V864M384 992H512V864H384M128 992H256V864H128V992Z",
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512 992H640V864H512V992Z",
    fill: "#404249",
    fillOpacity: 0.419608,
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640 992H768V864H640V992Z",
    fill: "#404249",
    fillOpacity: 0.898039,
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M768 992H896V864H768V992Z",
    fill: "#404249",
    fillOpacity: 0.109804,
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M896 992H1024V864H896V992Z",
    fill: "#404249",
    fillOpacity: 0.945098,
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1024 992H1152V864H1024V992Z",
    fill: "#404249",
    fillOpacity: 0.137255,
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1152 992H1280V864H1152V992Z",
    fill: "#404249",
    fillOpacity: 0.364706,
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1408 992H1536V864H1408V992Z",
    fill: "#404249",
    fillOpacity: 0.235294,
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1664 992H1536V864H1664M1664 992V864M1664 992H1792M1664 864H1792M1792 992V864M1792 992H1920V864H1792M128 864H0V736H128M128 864V736M128 864H255.999V736H128",
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256 864H384V736H256V864Z",
    fill: "#404249",
    fillOpacity: 0.403922,
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640 864H768V736H640V864Z",
    fill: "#404249",
    fillOpacity: 0.278431,
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M768 864H896V736H768V864Z",
    fill: "#404249",
    fillOpacity: 0.52549,
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1024 864H896V736H1024M1024 864V736M1024 864H1152V736H1024",
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1152 864H1280V736H1152V864Z",
    fill: "#404249",
    fillOpacity: 0.0431373,
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1280 864H1408V736H1280V864Z",
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1536 864H1664V736H1536V864Z",
    fill: "#404249",
    fillOpacity: 0.901961,
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1664 864H1792V736H1664V864Z",
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1792 864H1920V736H1792V864Z",
    fill: "#404249",
    fillOpacity: 0.913725,
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 736H128V608.001H0V736Z",
    fill: "#404249",
    fillOpacity: 0.933333,
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128 736H256V608.001H128V736ZM256.001 736H384V608.001H256.001V736Z",
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384 736H512V608.001H384V736Z",
    fill: "#404249",
    fillOpacity: 0.309804,
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640 736H512V608.001H640M640 736V608.001M640 736H768V608.001H640",
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M768 736H896V608.001H768V736Z",
    fill: "#404249",
    fillOpacity: 0.6,
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1024 736H896V608.001H1024M1024 736V608.001M1024 736H1152V608.001H1024",
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1152 736H1280V608.001H1152V736Z",
    fill: "#404249",
    fillOpacity: 0.180392,
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1408 736H1280V608.001H1408M1408 736V608.001M1408 736H1536M1408 608.001H1536M1536 736V608.001M1536 736H1664M1536 608.001H1664M1664 736V608.001M1664 736H1792V608.001H1664",
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1792 736H1920V608.001H1792V736Z",
    fill: "#404249",
    fillOpacity: 0.921569,
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 608H128V480H0V608Z",
    fill: "#404249",
    fillOpacity: 0.67451,
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128 608H256V480H128V608Z",
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256 608H384V480H256V608Z",
    fill: "#404249",
    fillOpacity: 0.764706,
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384 608H512V480H384V608Z",
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640 608H768V480H640V608Z",
    fill: "#404249",
    fillOpacity: 0.309804,
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M896 608H768V480H896M896 608V480M896 608H1024V480H896",
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1024 608H1152V480H1024V608Z",
    fill: "#404249",
    fillOpacity: 0.956863,
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1152 608H1280V480H1152V608Z",
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1280 608H1408V480H1280V608Z",
    fill: "#404249",
    fillOpacity: 0.729412,
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1536 608H1664V480H1536V608Z",
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1664 608H1792V480H1664V608Z",
    fill: "#404249",
    fillOpacity: 0.423529,
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128 480H0V352H128M128 480V352M128 480H255.999V352H128M256 480H384V352H256V480Z",
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384 480H512V352H384V480Z",
    fill: "#404249",
    fillOpacity: 0.984314,
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512 480H640V352H512V480Z",
    fill: "#404249",
    fillOpacity: 0.282353,
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M768 480H896V352H768V480ZM1024 480H1152V352H1024V480Z",
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1152 480H1280V352H1152V480Z",
    fill: "#404249",
    fillOpacity: 0.258824,
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1280 480H1408V352H1280V480Z",
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1408 480H1536V352H1408V480Z",
    fill: "#404249",
    fillOpacity: 0.14902,
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1664 480H1792V352H1664V480Z",
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1792 480H1920V352H1792V480Z",
    fill: "#404249",
    fillOpacity: 0.803922,
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 352H128V224.001H0V352Z",
    fill: "#404249",
    fillOpacity: 0.2,
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128 352H256V224.001H128V352Z",
    fill: "#404249",
    fillOpacity: 0.513726,
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384 352H256V224.001H384M384 352V224.001M384 352H511.999M384 224.001H511.999M511.999 352V224.001M511.999 352H639.999M511.999 224.001H639.999M639.999 352V224.001M639.999 352H768M639.999 224.001H768M768 352V224.001M768 352H895.999M768 224.001H895.999M895.999 352V224.001M895.999 352H1024V224.001H895.999",
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1024 352H1152V224.001H1024V352Z",
    fill: "#404249",
    fillOpacity: 0.243137,
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1152 352H1280V224.001H1152V352Z",
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1280 352H1408V224.001H1280V352Z",
    fill: "#404249",
    fillOpacity: 0.137255,
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1536 352H1408V224.001H1536M1536 352V224.001M1536 352H1664M1536 224.001H1664M1664 352V224.001M1664 352H1792M1664 224.001H1792M1792 352V224.001M1792 352H1920V224.001H1792M128 224H0V96H128M128 224V96M128 224H255.999V96H128",
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256 224H384V95.9999H256V224Z",
    fill: "#404249",
    fillOpacity: 0.309804,
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384 224H512V95.9999H384V224Z",
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512 224H640V95.9999H512V224Z",
    fill: "#404249",
    fillOpacity: 0.619608,
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M768 224H640V95.9999H768M768 224V95.9999M768 224H895.999M768 95.9999H895.999M895.999 224V95.9999M895.999 224H1024M895.999 95.9999H1024M1024 224V95.9999M1024 224H1152V95.9999H1024",
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1152 224H1280V95.9999H1152V224Z",
    fill: "#404249",
    fillOpacity: 0.337255,
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1280 224H1408V95.9999H1280V224Z",
    fill: "#404249",
    fillOpacity: 0.717647,
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1408 224H1536V95.9999H1408V224Z",
    fill: "#404249",
    fillOpacity: 0.733333,
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1536 224H1664V95.9999H1536V224Z",
    fill: "#404249",
    fillOpacity: 0.0235294,
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128 95.9999H0V-31.9997H128M128 95.9999V-31.9997M128 95.9999H255.999V-31.9997H128M384 95.9999H256V-31.9997H384M384 95.9999V-31.9997M384 95.9999H512V-31.9997H384M1792 224H1920V95.9999H1792V224Z",
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512 96H640V-31.9997H512V96Z",
    fill: "#404249",
    fillOpacity: 0.290196,
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M768 96H640V-31.9997H768M768 96V-31.9997M768 96H895.999M768 -31.9997H895.999M895.999 96V-31.9997M895.999 96H1024M895.999 -31.9997H1024M1024 96V-31.9997M1024 96H1152V-31.9997H1024",
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1280 96H1408V-31.9997H1280V96Z",
    fill: "#404249",
    fillOpacity: 0.168627,
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1408 96H1536V-31.9997H1408V96Z",
    fill: "#404249",
    fillOpacity: 0.882353,
    stroke: "#404249",
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1664 96H1536V-31.9997H1664M1664 96V-31.9997M1664 96H1792M1664 -31.9997H1792M1792 96V-31.9997M1792 96H1920V-31.9997H1792M128 -31.9997H0V-159.999H128M128 -31.9997V-159.999M128 -31.9997H255.999V-159.999H128M256 -31.9997H384V-159.999H256V-31.9997Z",
    stroke: "#404249",
    strokeWidth: 0.576
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundsquares1Hero);
export default __webpack_public_path__ + "static/media/backgroundsquares1-Hero.8d7ce95d692c29a42c1e2a351b7b3d49.svg";
export { ForwardRef as ReactComponent };